module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en-us":{"subscribed":"Opted in to your Marketing Number","unsubscribed":"Opted out of your Marketing Number","pending":"Pending opt in to your Marketing Number"}}')
  delete Component.options._Ctor
}
